import $ from "jquery"
import _ from "../utils/lodash"

const conservationKey = "[resume]"
const mfp_tr_color = "#FFFFFF"
const mfp_tr_color_over = "#FFFFFF"
const mfp_input_text_color_default = "#000000"
const mfp_input_text_color_error = "#FF0000"
const mfp_input_background_color_default = "#FFFFFF"
const mfp_input_background_color_error = "#FFEEEE"
const mfp_input_background_color_active = "#FFF5D6"
const mfp_input_border_color_active = "#FF9900"
const getpostcode_cgi = "/form/postcodes/get.cgi?"
const alert_display = false

let options = {}
let windowDimention = {
  w: 0,
  h: 0,
}

let intervalFunctions = []
const hasRequestAF = window.hasOwnProperty("requestAnimationFrame")
export const addFunction = (func) => {
  if (typeof func === "function") {
    intervalFunctions.push(func)
  }
}
export const removeFunction = (target) => {
  intervalFunctions = intervalFunctions.filter((func) => target !== func)
}
export const stopTimer = () => {
  if (hasRequestAF) {
    window.cancelAnimationFrame(reqId)
  } else {
    clearInterval(reqId)
  }
}

const timer = () => {
  intervalFunctions.forEach((func) => {
    if (typeof func === "function") func()
  })
  hasRequestAF &&
    setTimeout(() => {
      window.requestAnimationFrame(timer)
    }, 1000)
}

const reqId =
  (hasRequestAF && window.requestAnimationFrame(timer)) ||
  setInterval(timer, 1000)

export const getFormElementByName = (name) => {
  if (!_.isEmpty(options.obj)) {
    const elems = Object.values(options.obj)
    const index = _.findIndex(elems, (elem) => {
      return elem?.name === name
    })
    if (index > -1) {
      return elems[index]
    }
  }
  return null
}

export const getOptions = () => {
  if (_.isEmpty(options)) {
    options = {
      conservationKey,
      mfp_tr_color,
      mfp_tr_color_over,
      mfp_input_text_color_default,
      mfp_input_text_color_error,
      mfp_input_background_color_default,
      mfp_input_background_color_error,
      mfp_input_background_color_active,
      mfp_input_border_color_active,
      getpostcode_cgi,
      alert_display,
      obj: $("form#mailform")[0],
    }
    if (!_.isEmpty(options.obj)) {
      const inputElements = Object.values(options.obj)
      const index = _.findIndex(inputElements, (o) => {
        return o.name === "must_id"
      })
      if (index > -1) {
        options.must_id = inputElements[index].defaultValue
      }
    }
  }
  return options
}

export const setOptions = (newOptions) => {
  options = {
    ...options,
    ...newOptions,
  }
  return options
}

export const getDimention = () => {
  if (_.isEmpty(windowDimention)) {
    updateDimentionEvent()
  }
  return windowDimention
}

export const updateDimentionEvent = () => {
  windowDimention = {
    w: $(window).width(),
    h: $(window).height(),
    scrollTop: $(window).scrollTop(),
  }
}
